module.exports = __webpack_public_path__ + "static/media/skafferi-ikon.4dfe4080.png";